import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function NotarskoAdvokatskoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Notarsko i advokatsko pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Notarsko i advokatsko pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Notarsko i advokatsko pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Notarsko i advokatsko pravo je izučavanje
                notarijata i notarske djelatnosti definisanje pojma notarskog
                prava i načela notarske djelatnosti. Studenti će se upoznati sa
                subjektima notarske djelatnosti notarskim ispravama koje imaju
                značaj javnih isprava sa notarskim ovjerama zapisnicima i
                potvrdama te organizacijom notarske komore Crne Gore. Takođe
                cilj ovog predmeta je izučavanje advokatske djelatnosti načela
                advokature etičkog kodeksa advokata organizacijom advokatske
                komore Crne Gore kao i pozitivno pravnih akata kojima je
                uređenja advokatska djelatnost.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Na kraju uspješno savladanog predmeta studenti će se osposobiti
                za praktična rješenja iz djelatnosti notarskog i advokatskog
                prava. Nadalje ishodi predmera podrazumijevaju sticanje znanja o
                organizaciji notarijata u Crnoj Gori i pravnim položajem notara
                u evropskim pravnim sistemima i u našem pravu. Shvatanje razlike
                između notara advokata i sudije. Razvijanje vještina kroz
                analizu i tumačenje relevantnih pravnih akata. Takođe studenti
                će steći osnovna znanja o notarima i advokatima koja će im u
                budućim angažmanima biti od značaja radi bržeg i boljeg
                prilagođavanja i obavljanja zadatih poslova.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Pojam notarskog prava notarijata i notarske
                djelatnosti; Značaj notarske djelatnosti; Izvori notarskog
                prava. Organizacija notarijata u uporednom pravu (državni
                notarijat advokatski notarijat notarijat latinskog tipa); Pravne
                karakteristike notarijata u Crnoj Gori. Načela notarske
                djelatnosti: Subjekti notarske djelatnosti izbor i razrješenje
                notara; notarski pripravnik saradnik i zamjenik notara Notarski
                akti pojam i značaj vrste notarskih akata i forma. Notarski
                zapis: Pojam značaj i karakteristike sadržina. Notarski zapisnik
                Postupak za sačinjavanje Solemnizacija: pojam značaj
                karakteristike postupak za sačinjavanje. Notarske potvrde
                Notarske ovjere: Depozit kod notara Notarski spisi i vođenje
                knjiga. Odgovornost notara; Organizacija notarske komore;
                Advokatska djelatnost način i oblici rada advokata; prava
                obaveze i odgovornosti advokata i advokatskih pripravnika;
                Načela advokatske djelatnosti; Advokatski poslovi; Advokatske
                vještine; Odgovornost advokata: Disciplinska odgovornost
                advokata; Građanskopravna odgovornost advokata; Krivična
                odgovornost advokata; Advokatska komora; organizacija nadležnost
                članstvo prava i obaveze
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Pojam notarskog prava notarijata i notarske djelatnosti;
                      Značaj notarske djelatnosti; Izvori notarskog prava.
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Organizacija notarijata u uporednom pravu (državni
                      notarijat advokatski notarijat notarijat latinskog tipa);
                      Pravne karakteristike notarijata u Crnoj Gori
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Načela notarske djelatnosti: načelo slobodnog pristupa
                      notaru načelo povjerljivosti načelo nepristrasnosti
                      teritorijalni princip.
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Subjekti notarske djelatnosti izbor i razrješenje notara;
                      notarski pripravnik saradnik i zamjenik notara
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Notarski akti pojam i značaj vrste notarskih akata i forma
                      +Praktična nastava. Posjeta notarskim kancelarijama.
                      Pisanje notarskih akata.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P + 2V</td>
                    <td>
                      Notarski zapis: Pojam značaj i karakteristike sadržina;
                      Notarski zapisnik Postupak za sačinjavanje
                    </td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Solemnizacija: pojam značaj karakteristike postupak za
                      sačinjavanje + Praktična nastva. Posjeta notarskoj komori.
                      Pisanje notarskih zapisa.
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Notarske potvrde Notarske ovjere; Depozit kod notara
                      Notarski spisi i vođenje knjiga
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Odgovornost notara: Disciplinska odgovornost notara;
                      Građanskopravna odgovornost notara; Organizacija notarske
                      komore
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>
                      Advokatska djelatnost način i oblici rada advokata; prava
                      obaveze i odgovornosti advokata i advokatskih pripravnika;
                      Načela advokatske djelatnosti + Praktična nastava. Posjeta
                      advokatskim i notarskim kancelarijma. Pisanje podnesaka.
                      Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>Advokatski poslovi; Advokatske vještine;</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P + 2V</td>
                    <td>
                      Odgovornost advokata: Disciplinska odgovornost advokata;
                      Građanskopravna odgovornost advokata; Krivična odgovornost
                      advokata; + Praktična nastava: Posjeta advokatskim
                      kancelarijama i advokatskoj komori
                    </td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Advokatska komora; organizacija nadležnost članstvo prava
                      i obaveze + Praktična nastava.. Prisustvovanje suđenjima.
                      Analiza sudske prakse. Simulacije suđenja.
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>2P + 2V</td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 1.3h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NotarskoAdvokatskoPravo;
